import React from 'react';
import loadable from '@loadable/component';

const FilterNav = loadable(
  () =>
    import(/* webpackChunkName: "FilterNav.loadable" */ 'app/shared/modules/navigation/FilterNav/FilterNavComponent'),
);

const LoadableFilterNav = () => {
  return <FilterNav />;
};

export default LoadableFilterNav;
